import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import ScrollToTopButton from '../../components/ScrollToTopButton';
import './Main.scss';
import { GLANCE_HEADLINE, GlanceGrid } from '../serviceinfo/serviceGlance';
// images/mockup.png(1.9MB)을 가로 1200px webp로 줄인 사본
import mockup from '../../images/mockup-web.webp';
import { PLAN_TIERS, formatManwon } from '../price/pricingData';

const START_FEE = formatManwon(PLAN_TIERS[0].base).replace(' ', ''); // '3만원'

const COMPARE_OTHER = [
  '앱 하나를 만들어도 초기 개발비 전액 부담',
  '기능 추가·수정 시 개발 비용 별도',
  '유지보수·사후 관리 계약 별도',
];

const COMPARE_MORE = [
  '초기 개발비 없이 월 구독으로 시작',
  '5개 앱(성도·관리·교적부·재정·주일학교)을 한 번에',
  '교회 로고·컬러 커스텀, 출시 후 평생 사용',
];

// 홈페이지(외부용) vs 교회 전용 앱(내부용) 비교
const DOOR_ROWS = [
  { label: '주 사용자', web: '처음 오는 분 · 이사 온 분 · 방문객', app: '지금 출석하는 성도' },
  { label: '목적', web: '교회 소개 · 첫인상 · 신뢰', app: '소통 · 목양 · 행정 · 관리' },
  { label: '사용 빈도', web: '방문·검색할 때 (낮음)', app: '매주, 거의 매일 (높음)' },
  { label: '닿는 방식', web: '사용자가 직접 검색해야 보임', app: '교회가 먼저 알림을 보냄' },
  { label: '소속감', web: '단순한 정보 전달', app: '우리 교회 앱이라는 정체성' },
  { label: '개인화', web: '익명 방문 중심', app: '로그인 기반 개인 데이터 축적 가능' },
  
];

const FAQS = [
  {
    q: '성도님들 중에 어르신이 많은데, 앱 사용을 어려워하지 않으실까요?',
    a: '물론 걱정되실 수 있습니다! 하지만 교회앱모아는 글자 크기 확대 기능과 한 번의 클릭으로 설교가 재생되는 직관적 UI로 설계되었습니다. 실제로 70대 이상 성도 비중이 40%인 교회에서 테스트 결과, 첫 주 만에 85% 이상의 설치율을 기록했습니다.',
  },
  {
    q: '교회 안에 IT나 컴퓨터를 잘 다루는 담당자가 없는데 운영이 가능할까요?',
    a: '관리자 페이지는 블로그 글쓰기보다 쉽게 제작되었습니다. 전담 고객지원 팀이 초기 세팅부터 세부 메뉴 등록까지 네비게이션처럼 1:1로 함께 동행해 드립니다.',
  },
  {
    q: '앱 출시까지 얼마나 걸리나요?',
    a: '신청 후 통상 2~4주 안에 App Store와 Google Play에 동시 배포됩니다. 교회 규모와 커스텀 범위에 따라 일정은 조정될 수 있습니다.',
  },
  {
    q: '성도 개인정보(교적)는 안전한가요?',
    a: '교회별로 데이터를 분리해 운영하고, 담당자 권한별로 접근을 통제하며, 가입 승인 절차를 거친 담당자만 교적을 볼 수 있도록 관리합니다. 규모가 큰 교회는 단독 서버로도 운영할 수 있습니다.',
  },
  {
    q: '교단·교회 색깔에 맞출 수 있나요?',
    a: '네. 교회 로고·컬러·이미지를 기반으로 한 커스텀 디자인을 기본으로 제공합니다.',
  },
  {
    q: '중간에 그만두면 어떻게 되나요?',
    a: '월 구독 구조라 초기 개발비 부담이 없고, 계약 조건은 시작 전에 투명하게 안내해 드립니다.',
  },
  {
    q: '기존 홈페이지·유튜브와 연동되나요?',
    a: '네. 설교 영상, 주보 등 기존에 운영하던 채널과 연동해 사용할 수 있습니다.',
  },
];

const REVIEWS = [
  {
    text: '교회가 시대에 뒤처진다는 느낌이 있었는데,\n앱을 사용해보니 오히려 한발 앞서가는 느낌이 들었어요.',
    name: '교****',
  },
  {
    text: '전체적으로 화면이 심플하고\n직관적이라 사용하기 편했어요.',
    name: '서*******',
  },
  {
    text: '기존의 다른 앱들보다 디자인이 깔끔해서\n사용하기 편해요.',
    name: '예******',
  },
  {
    text: '우리 교회만의 앱이 생기니까 소속감도 더 생기고,\n교인들과 소통하기도 훨씬 편해졌어요.',
    name: '대******',
  },
];

const PROCESS = [
  {
    num: '01',
    title: '신청',
    desc: '신청서에 교회 규모와 사용할 앱만 적어 주세요. 몇 분이면 충분합니다.',
  },
  {
    num: '02',
    title: '디자인',
    desc: '교회 로고·컬러·이미지에 맞춘 커스텀 앱 디자인 확정.',
  },
  {
    num: '03',
    title: '출시',
    desc: 'App Store와 Google Play에 동시 배포. 그 후 평생 사용.',
  },
];

const STATS = [
  { num: '230', suffix: '+', label: 'Deployed Churches' },
  { num: '180K', label: 'Active Members' },
  { num: '4.8', label: 'App Store Rating' },
  { num: '96%', label: 'Renewal Rate' },
];

export default function Main() {
  useEffect(() => {
    const nodes = document.querySelectorAll('.main .reveal');
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );

    nodes.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <div className="main">
      <Header />

      <section className="promo">
        <div className="container promo-inner">
          <div className="promo-copy reveal">
            <p className="promo-kicker">스마트하게 소통하는</p>
            <h1 className="promo-title">
              우리 교회
              <br />
              전용 앱
            </h1>
            <div className="promo-desc">
              <p>
                3주 안에 완성되는
                <br />
                프리미엄 교회 전용 모바일 애플리케이션.
              </p>
            </div>
            <div className="cta-row">
              <a href="#contact" className="btn-primary">
                무료 견적 요청 <span aria-hidden="true">→</span>
              </a>
            </div>
            <div className="meta-row">
              <span>Production in 14 days</span>
              <span>iOS &amp; Android</span>
              <span>Lifetime Updates</span>
            </div>
          </div>
          <div className="promo-visual reveal">
            <p className="promo-bubble promo-bubble-top">
              우리 교회 이름으로 된 앱을 사용해보세요!
            </p>
            <img className="promo-mockup" src={mockup} alt="교회 앱 화면 목업" />
            <p className="promo-bubble promo-bubble-bottom">
              월 {START_FEE}으로 교회 전용 앱을
              사용해보세요.
            </p>
          </div>
        </div>
      </section>

      <section className="doors">
        <div className="container">
          <div className="doors-head reveal">
            <p className="doors-kicker">왜 홈페이지가 아니라 앱이어야 할까요?</p>
            <h2>
              홈페이지는 <span className="hl-web">외부 홍보용</span>,
              <br />
              앱은 <span className="hl-app">내부 성도용</span>입니다.
            </h2>
            <p>사용자가 다르면 도구도 달라야 합니다.</p>
          </div>

          <div className="doors-grid reveal">
            <div className="door-card door-web">
              <div className="door-top">
                <span className="door-tag">외부용</span>
                <h3>홈페이지</h3>
                <p>새로 오는 분을 위한 문</p>
              </div>
              <dl>
                {DOOR_ROWS.map((row) => (
                  <div className="door-row" key={row.label}>
                    <dt>{row.label}</dt>
                    <dd>{row.web}</dd>
                  </div>
                ))}
              </dl>
            </div>

            <div className="door-card door-app">
              <div className="door-top">
                <span className="door-tag">내부용</span>
                <h3>교회 전용 앱</h3>
                <p>이미 함께하는 성도를 위한 문</p>
              </div>
              <dl>
                {DOOR_ROWS.map((row) => (
                  <div className="door-row" key={row.label}>
                    <dt>{row.label}</dt>
                    <dd>{row.app}</dd>
                  </div>
                ))}
              </dl>
            </div>
          </div>

          <div className="doors-callout reveal">
            <p className="doors-q">&ldquo;이미 홈페이지가 있는데, 앱이 또 필요할까요?&rdquo;</p>
            <p>
              지금 출석하는 성도는 홈페이지를 자주 찾지 않습니다. 홈페이지를 아무리 잘 만들어도,{' '}
              <br className="br-pc" />
              이미 온 성도와 매주 소통하고 교적·출석을 챙기는 <strong>내부 채널</strong>은 여전히 비어 있습니다.
            </p>
            <p className="doors-a">
              교회앱모아는 홈페이지를 대신하는 것이 아니라,{' '}
              <br className="br-pc" />
              <strong>성도를 위한 내부 목양 채널</strong>을 새로 여는 것입니다.
            </p>
          </div>
        </div>
      </section>

      <section className="faq">
        <div className="container">
          <div className="faq-head reveal">
            <span className="faq-eyebrow">FAQ</span>
            <h2>자주 묻는 질문</h2>
          </div>
          <div className="faq-list">
            {FAQS.map((faq, i) => (
              <details className="faq-item reveal" key={faq.q} open={i === 0}>
                <summary className="faq-q">
                  <span className="faq-badge">Q{i + 1}</span>
                  <p>{faq.q}</p>
                  <span className="faq-toggle" aria-hidden="true" />
                </summary>
                <div className="faq-a">
                  <span className="faq-badge">A</span>
                  <p>{faq.a}</p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </section>

      <section className="reviews">
        <div className="container">
          <div className="reviews-head reveal">
            <div>
              <p className="reviews-kicker">우리 교회의 더 나은 내일을 위한 첫걸음</p>
              <h2>
                <span className="em">우리 교회만의 앱,</span>
                <br />
                아직 없으신가요?
              </h2>
            </div>
            <div>
              <p className="reviews-sub">
                흩어진 교회 소통과 운영,
                <br />
                <strong>전용 앱 하나</strong>로 정리해보세요.
              </p>
            </div>
          </div>

          <div className="reviews-label reveal">
            <span className="reviews-label-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24">
                <path d="M2 21h4V9H2v12zm20-11a2 2 0 0 0-2-2h-6.3l1-4.6v-.3c0-.4-.2-.8-.4-1.1L13.2 1 6.6 7.6c-.4.4-.6.9-.6 1.4v10a2 2 0 0 0 2 2h9c.8 0 1.5-.5 1.8-1.2l3-7.1c.1-.2.2-.5.2-.7v-2z" />
              </svg>
            </span>
            실제 사용자들의 후기
          </div>

          <div className="reviews-list">
            {REVIEWS.map((review) => (
              <figure className="review-card reveal" key={review.name}>
                <span className="review-quote" aria-hidden="true">
                  &ldquo;
                </span>
                <blockquote>{review.text}</blockquote>
                <figcaption>
                  <span className="review-avatar" aria-hidden="true">
                    <svg viewBox="0 0 24 24">
                      <circle cx="12" cy="8" r="4.2" />
                      <path d="M3.5 21c.8-4.4 4.3-7 8.5-7s7.7 2.6 8.5 7z" />
                    </svg>
                  </span>
                  {review.name}
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </section>

      {/* <section className="stats reveal">
        <div className="stats-inner">
          {STATS.map((stat) => (
            <div className="stat" key={stat.label}>
              <div className="stat-num">
                {stat.num}
                {stat.suffix ? <sup>{stat.suffix}</sup> : null}
              </div>
              <div className="stat-label">{stat.label}</div>
            </div>
          ))}
        </div>
      </section> */}

      {/* <section className="glance" id="service">
        <div className="container">
          <div className="section-head reveal">
            <span className="eyebrow light">At a Glance</span>
            <h2>
              {GLANCE_HEADLINE.services},
              <br />
              <span className="em">{GLANCE_HEADLINE.apps}</span> 앱.
            </h2>
          </div>
          <GlanceGrid />
          <div className="glance-more reveal">
            <Link to="/service/member">성도 앱</Link>
            <Link to="/service/admin">앱관리 앱</Link>
            <Link to="/service/roll">교적부 앱</Link>
            <Link to="/service/finance">재정 앱</Link>
            <Link to="/service/sundayschool">주일학교 앱</Link>
          </div>
        </div>
      </section> */}

      <section className="process">
        <div className="container">
          <div className="section-head reveal">
            <span className="eyebrow">Process</span>
            <h2>
              3단계, 그리고
              <br />
              우리 교회의 <span className="em">앱</span>이 됩니다.
            </h2>
          </div>
          <div className="process-list reveal">
            {PROCESS.map((step) => (
              <div className="process-item" key={step.num}>
                <div className="process-num">{step.num}</div>
                <div className="process-title">{step.title}</div>
                <div className="process-desc">{step.desc}</div>
                <div className="process-arr" aria-hidden="true">
                  ——
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="compare" id="compare">
        <div className="container">
          <div className="compare-head reveal">
            <span className="compare-eyebrow">Cost Compare</span>
            <h2>
              앱 하나에 <span className="hl">약 2천만원</span>,
              <br />
              그 부담, 없어도 됩니다.
            </h2>
            <p>
              타 외부 업체에 교회 앱을 맡기면 앱 하나에 최소 2,000만원이 들지만,{' '}
              <br />
              교회앱모아는 초기 개발비 없이 월 {START_FEE}부터 시작합니다.
            </p>
          </div>

          <div className="compare-grid reveal">
            <div className="cmp-card cmp-other">
              <span className="cmp-who">타 외부 업체</span>
              <div className="cmp-cap">초기 개발비 · 앱 1개 기준</div>
              <div className="cmp-price">
                약 2,000 만원
              </div>
              <ul>
                {COMPARE_OTHER.map((item) => (
                  <li key={item}>
                    <svg viewBox="0 0 24 24" aria-hidden="true">
                      <path d="M6 6l12 12M18 6L6 18" />
                    </svg>
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            <div className="cmp-vs" aria-hidden="true">
              VS
            </div>

            <div className="cmp-card cmp-more">
              <span className="cmp-who">교회앱모아</span>
              <div className="cmp-cap">성도용 앱(기본) · {PLAN_TIERS[0].size} 교회</div>
              <div className="cmp-price">
                월 {PLAN_TIERS[0].base / 10000} 만원부터
              </div>
              <ul>
                {COMPARE_MORE.map((item) => (
                  <li key={item}>
                    <svg viewBox="0 0 24 24" aria-hidden="true">
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="cmp-btn-row reveal">
            <Link className="cmp-btn" to="/price" onClick={() => window.scrollTo(0, 0)}>
              요금 자세히 보기 <span aria-hidden="true">→</span>
            </Link>
          </div>
          <p className="cmp-note reveal">
            ※ 외부 업체 개발 비용은 커스텀 앱 개발 시 일반적인 견적 기준이며, 규모·기능에 따라 달라질 수
            있습니다.
          </p>
        </div>
      </section>

      <section className="final-cta" id="contact">
        <div className="container final-cta-inner reveal">
          <h2>
            우리 교회의 이야기를,
            <br />
            앱으로 시작해보세요.
          </h2>
          <Link to="/inquiry" className="btn-cream" onClick={() => window.scrollTo(0, 0)}>
            신청하기 &nbsp;→
          </Link>
        </div>
      </section>

      <ScrollToTopButton />
      <Footer />
    </div>
  );
}
